
<section #containerPortfolio id="containerPortfolio" class="section portfolio active">
  <div class="tab-box">
    <div
      *ngFor="let tab of tabs; let i = index"
      class="tab-list portfolio-list"
      [class.active]="i === activeIndex"
      (click)="setActive(i)"
    >
      <i [class]="tab.icon" class="tab-icon"></i>
      <h3 class="tab-label" data-translate="{{ tab.label }}"></h3>

    </div>
  </div>


  <div class="tab-wrapper">

    <div class="tab-grid work" [class.active]="activeIndex === 0" *ngIf="activeIndex === 0" appHideShellOnScroll [scrollKey]="'portfolio-work-light'" [hideNav]="false"
        [hideDock]="true" [hideFooter]="false">
      <div *ngFor="let work of tabContent.work; let i = index" class="tab-item">
        <div class="work-img">
          <img [src]="work.IMG_SRC" alt="">
        </div>
        <div class="work-info">
          <h4 [attr.data-translate]="'PORTFOLIO.CONTENT.WORK.' + i + '.TITLE'"></h4>
          <p [attr.data-translate]="'PORTFOLIO.CONTENT.WORK.' + i + '.DESCRIPTION'"></p>
          <div class="tech-used">
            <p [attr.data-translate]="'PORTFOLIO.CONTENT.WORK.' + i + '.PROGRAM_LANGS'"></p>
          </div>
          <div class="portfolio-icon work-icon">
            <a [href]="previewLinks[i]" target="_blank">
              <i class="bx bx-arrow-back"></i>
              <span class="tooltip">Preview</span>
            </a>
          </div>
        </div>
      </div>
    </div>


    <div class="tab-grid service" [class.active]="activeIndex === 1" *ngIf="activeIndex === 1" appHideShellOnScroll [scrollKey]="'portfolio-service-light'" [hideNav]="false"
        [hideDock]="true" [hideFooter]="false">
      <div *ngFor="let service of tabContent.service; let i = index" class="tab-item">
        <div class="portfolio-icon service-icon">
          <i [class]="service.ICON"></i>
          <!-- <a href=""><i class="bx bx-arrow-back"></i></a> -->
        </div>
        <h4 [attr.data-translate]="'PORTFOLIO.CONTENT.SERVICE.' + i + '.CATEGORY'"></h4>
        <p [attr.data-translate]="'PORTFOLIO.CONTENT.SERVICE.' + i + '.DESCRIPTION'"></p>
      </div>
    </div>


  </div>

  <app-footer (toggleImprint)="toggleImprint.emit()" (togglePrivacy)="togglePrivacy.emit()"></app-footer>
</section>
